import { useUserFeatures } from "../../contexts/UserFeaturesContext";

/**
 * Whether to frame a payment set by direction ("To/From", +/- amounts,
 * sending/collecting/net totals).
 *
 * Direction matters when the user can choose collect, or when the set already
 * holds a collect row. Template rows carry their own direction, so a role with
 * template-collect but no direct-collect still needs collect framing.
 */
const useShowCollectAmounts = (hasCollectRows: boolean): boolean => {
  const { ach_payments_collect: achPaymentsCollectFeature } = useUserFeatures();
  return Boolean(achPaymentsCollectFeature) || hasCollectRows;
};

export default useShowCollectAmounts;
